export default function FooterAddress() {
  return (
    <div className="hidden md:mx-auto md:block md:w-[200px] md:text-center lg:grow-[3] lg:text-left">
      <address className="py-[3px] text-[14px] leading-5">
        The Sole Supplier
        <br />
        3rd Floor
        <br />
        86-90 Paul Street
        <br />
        London EC2A 4NE
        <br />
      </address>
    </div>
  );
}
